export const LOAD_USERS = 'globalappstate/LOAD_USERS';
export const SET_SELECTED_USER = 'globalappstate/SET_SELECTED_USER';
export const LOAD_PICKLISTS = 'globalappstate/LOAD_PICKLISTS';